module.exports = __webpack_public_path__ + "static/media/fye-foot-right.ef7a34fc.png";